function getDynamicComponentInfo(name = '', superProps = {}, rest = {}) {
  const {
    showLoader = true,
    componentType = 'page',
    desktop = true,
    requireLayout = true,
    otherParams = {}
  } = rest;

  let componentInfoResponseObj = {
    name,
    showLoader,
    componentType,
    superProps,
    desktop,
    otherParams,
    requireLayout
  };

  if (rest.hasOwnProperty('customLayout')) {
    componentInfoResponseObj = {
      ...componentInfoResponseObj,
      customLayout: rest.customLayout
    };
  }
  return componentInfoResponseObj;
}

module.exports = {
  getDynamicComponentInfo
};
